import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PhasesMasters } from '@/shared/models/phasesMasters.model';
import { GET_PHASESMASTERS } from '@/shared/services/queries/phasesMasters.graphql';

@Injectable({
  providedIn: 'root',
})
export class PhasesMastersService {
  private readonly apollo = inject(Apollo);
  getPhasesMasters(): Observable<PhasesMasters[]> {
    return (
      this.apollo
        .watchQuery({
          query: GET_PHASESMASTERS,
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .valueChanges.pipe(map((result: any) => result.data.phasesMasters))
    );
  }
}
